import React from "react";

import {
  FiClock,
  FiEye,
  FiTrash2,
  FiUsers,
} from "react-icons/fi";

import {
  FaSpinner,
} from "react-icons/fa";

import EmployeePagination
  from "../common/EmployeePagination";

import EmployeeStatusBadge
  from "../common/EmployeeStatusBadge";

import {
  formatEmployeeDate,
} from "../utils/employee.utils";

import "./EmployeeAttendance.css";


const EmployeeAttendanceTable = ({
  records = [],

  loading = false,

  page = 1,

  limit = 20,

  totalRecords = 0,

  totalPages = 1,

  onPageChange,

  onLimitChange,

  onView,

  onDelete,
}) => {

  if (
    loading
  ) {

    return (

      <div className="employee-attendance-loading">

        <FaSpinner />

        <span>
          Loading attendance...
        </span>

      </div>

    );

  }


  return (

    <section className="employee-attendance-table-card">

      <div className="employee-attendance-table-heading">

        <div>

          <span>
            ATTENDANCE REGISTER
          </span>

          <h2>
            Attendance Records
          </h2>

          <p>
            Daily employee attendance, check-in and check-out records.
          </p>

        </div>

      </div>


      <div className="employee-attendance-table-scroll">

        <table className="employee-attendance-table">

          <thead>

            <tr>

              <th>
                #
              </th>

              <th>
                Employee
              </th>

              <th>
                Date
              </th>

              <th>
                Status
              </th>

              <th>
                Check In
              </th>

              <th>
                Check Out
              </th>

              <th>
                Working Hours
              </th>

              <th>
                Remark
              </th>

              <th>
                Actions
              </th>

            </tr>

          </thead>


          <tbody>

            {
              records.length ===
              0
                ?
                (
                  <tr>

                    <td
                      colSpan="9"
                      className="employee-attendance-empty"
                    >

                      <FiUsers />

                      <strong>
                        No attendance records found
                      </strong>

                      <span>
                        Mark attendance for employees to begin.
                      </span>

                    </td>

                  </tr>
                )
                :
                records.map(
                  (
                    attendance,
                    index
                  ) => {

                    const employee =
                      attendance?.employeeId &&
                      typeof attendance.employeeId ===
                        "object"
                        ?
                        attendance.employeeId
                        :
                        attendance?.employee ||
                        {};


                    return (

                      <tr
                        key={
                          attendance?._id ||
                          index
                        }
                      >

                        <td>

                          {
                            (
                              Number(
                                page
                              ) -
                              1
                            ) *
                            Number(
                              limit
                            ) +
                            index +
                            1
                          }

                        </td>


                        <td>

                          <div className="employee-attendance-person">

                            <strong>
                              {
                                employee?.name ||
                                attendance?.employeeName ||
                                "-"
                              }
                            </strong>

                            <span>
                              {
                                employee?.employeeCode ||
                                attendance?.employeeCode ||
                                "-"
                              }
                            </span>

                          </div>

                        </td>


                        <td>

                          <strong>
                            {
                              formatEmployeeDate(
                                attendance
                                  ?.attendanceDate ||
                                attendance
                                  ?.date
                              )
                            }
                          </strong>

                        </td>


                        <td>

                          <EmployeeStatusBadge
                            status={
                              attendance
                                ?.status
                            }
                          />

                        </td>


                        <td>

                          <span className="employee-attendance-time">

                            <FiClock />

                            {
                              attendance
                                ?.checkIn ||
                              "-"
                            }

                          </span>

                        </td>


                        <td>

                          <span className="employee-attendance-time">

                            <FiClock />

                            {
                              attendance
                                ?.checkOut ||
                              "-"
                            }

                          </span>

                        </td>


                        <td>

                          <strong>

                            {
                              attendance
                                ?.workingHours ??
                              attendance
                                ?.totalHours ??
                              "-"
                            }

                          </strong>

                        </td>


                        <td>

                          <span className="employee-attendance-remark">

                            {
                              attendance
                                ?.remark ||
                              "-"
                            }

                          </span>

                        </td>


                        <td>

                          <div className="employee-attendance-actions">

                            <button
                              type="button"
                              onClick={
                                () =>
                                  onView?.(
                                    attendance
                                  )
                              }
                              title="View"
                            >

                              <FiEye />

                            </button>


                            <button
                              type="button"
                              className="employee-attendance-delete-action"
                              onClick={
                                () =>
                                  onDelete?.(
                                    attendance
                                  )
                              }
                              title="Delete"
                            >

                              <FiTrash2 />

                            </button>

                          </div>

                        </td>

                      </tr>

                    );

                  }
                )
            }

          </tbody>

        </table>

      </div>


      {
        totalRecords >
        0
          ?
          (
            <EmployeePagination
              page={
                page
              }
              limit={
                limit
              }
              totalRecords={
                totalRecords
              }
              totalPages={
                totalPages
              }
              onPageChange={
                onPageChange
              }
              onLimitChange={
                onLimitChange
              }
            />
          )
          :
          null
      }

    </section>

  );

};


export default EmployeeAttendanceTable;